export type ImpersonationType = 'user' | 'tenant_admin';

export interface ImpersonationActor {
  id: string;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  tenantId: string | null;
}

export interface ImpersonationTarget {
  id: string;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  tenantId: string | null;
}

export function canImpersonate(
  actor: ImpersonationActor,
  target: ImpersonationTarget,
  impersonationType: ImpersonationType
): boolean {
  if (actor.id === target.id) {
    return false;
  }

  if (target.isSuperAdmin) {
    return false;
  }

  if (actor.isSuperAdmin) {
    if (impersonationType === 'tenant_admin') {
      return target.isAdmin;
    }

    return true;
  }

  if (!actor.isAdmin || actor.isSuperAdmin || !actor.tenantId) {
    return false;
  }

  if (impersonationType !== 'user') {
    return false;
  }

  return (
    target.tenantId === actor.tenantId &&
    !target.isAdmin &&
    !target.isSuperAdmin
  );
}
